import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { ThemeProvider } from './theme/ThemeContext';
import { getCachedBrand } from './hooks/useChurchConfig';
import reportWebVitals from './reportWebVitals';

// Clean URLs (/churchManag/settings/registration), not hash URLs
// (/churchManag/#/settings/registration).
//
// The app is served from a sub-path (PUBLIC_URL, e.g. /churchManag). A clean
// path opened directly or refreshed reaches the web server, which must answer
// with index.html for any unknown /churchManag/** path — public/.htaccess does
// that on Apache; any other server needs the same rule. The dev server does
// this already.
// '/churchManag' in production; '/' (the root) is written as '' so paths never start '//'.
const basename = (process.env.PUBLIC_URL || '').replace(/\/+$/, '');

// Links from the hash-URL days — bookmarks, and registration links and QR
// codes already shared with families — carry the route after '#'. Move it into
// the path before the router starts, so every old link keeps working.
if (window.location.hash.startsWith('#/')) {
  const route = window.location.hash.slice(1);
  window.history.replaceState(null, '', `${basename}${route}`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      {/* The cached brand colour paints correctly on the very first frame;
          ChurchConfigSync then reconciles it with the server. */}
      <ThemeProvider initialBrand={getCachedBrand()}>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
